import styled from 'styled-components'
import { Colors } from '~/styles'

export const Title = styled.p`
    font-size: 13px;
    line-height: 5px;
    color: ${Colors.stoneBlack};
`
export const ContainerTitle = styled.div`
    display: flex;
    margin-bottom: 1px;
    flex-direction: row;
`
export const Container = styled.div`
    display: flex;
    margin-bottom: 32px;
    flex-direction: column;
`
export const Wrapper = styled.div`
    height:45px;
    border-radius: 6px;
    flex-direction: row;
    align-items: center;
    justify-content:center;
    box-sizing: border-box;
    background: ${Colors.white};
`
export const FormatDate = styled.div`
    width: 100%;
    height: 40px;
    transform: translate3d(10px, 10px, 10px);
`
export const ErrorText = styled.p`
    margin: 0;
    color: ${Colors.errorRed};
    font-size: 0.75rem;
`
export const RedStar = styled.span`
    font-size: 13px;
    line-height: 5px;
    color: ${Colors.red};
`

export default {
	Title,
	Wrapper,
	RedStar,
	Container,
	ErrorText,
	FormatDate,
	ContainerTitle,
}